import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}(); // FHT Swagger jQuery client V2

/* eslint-disable */


import { BaseApi } from "./api";

var CompanyMemberApiApi =
/** @class */
function (_super) {
  __extends(CompanyMemberApiApi, _super);

  function CompanyMemberApiApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.companyMemberApiAcceptApplyRequest = function (p) {
      var localVarPath = '/api/companymembers/_acceptApplyRequest/{applyRequestId}'.replace('{' + 'applyRequestId' + '}', String(p["applyRequestId"]));

      _this.r(p, ["applyRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiAcceptInviteRequest = function (p) {
      var localVarPath = '/api/companymembers/_acceptInviteRequest/{inviteRequestId}'.replace('{' + 'inviteRequestId' + '}', String(p["inviteRequestId"]));

      _this.r(p, ["inviteRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiAnalysisInvitationCode = function (p) {
      var localVarPath = '/api/companymembers/_analysisinvitationcode';

      _this.r(p, ["code"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiApply = function (p) {
      var localVarPath = '/api/companymembers/_apply';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiAssignSubAdmin = function (p) {
      var localVarPath = '/api/companymembers/_assignSubAdmin/{memberId}'.replace('{' + 'memberId' + '}', String(p["memberId"]));

      _this.r(p, ["memberId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiCancelApplyRequest = function (p) {
      var localVarPath = '/api/companymembers/_cancelApplyRequest/{applyRequestId}'.replace('{' + 'applyRequestId' + '}', String(p["applyRequestId"]));

      _this.r(p, ["applyRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiCancelInviteRequest = function (p) {
      var localVarPath = '/api/companymembers/_cancelInviteRequest/{inviteRequestId}'.replace('{' + 'inviteRequestId' + '}', String(p["inviteRequestId"]));

      _this.r(p, ["inviteRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGenInvitationCode = function () {
      var localVarPath = '/api/companymembers/_geninvitationcode';
      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, {}, bodyDict);
    };

    _this.companyMemberApiGetCompanyAllMembersByCompanyId = function (p) {
      var localVarPath = '/api/companies/{companyId}/members'.replace('{' + 'companyId' + '}', String(p["companyId"]));

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetCompanyMembers = function () {
      var localVarPath = '/api/companymembers';
      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, {}, bodyDict);
    };

    _this.companyMemberApiGetCustomerServices = function () {
      var localVarPath = '/api/companymembers/customerServices';
      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, {}, bodyDict);
    };

    _this.companyMemberApiGetIncomingCompanyMemberApplyRequest = function (p) {
      var localVarPath = '/api/incomingCompanyMemberApplyRequests/{applyRequestId}'.replace('{' + 'applyRequestId' + '}', String(p["applyRequestId"]));

      _this.r(p, ["applyRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetIncomingCompanyMemberApplyRequests = function (p) {
      var localVarPath = '/api/incomingCompanyMemberApplyRequests';

      _this.r(p, ["args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetIncomingCompanyMemberApplyRequestsCount = function (p) {
      var localVarPath = '/api/incomingCompanyMemberApplyRequests/unreadcount';

      _this.r(p, []);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetIncomingCompanyMemberInviteRequest = function (p) {
      var localVarPath = '/api/incomingCompanyMemberInviteRequests/{inviteRequestId}'.replace('{' + 'inviteRequestId' + '}', String(p["inviteRequestId"]));

      _this.r(p, ["inviteRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetIncomingCompanyMemberInviteRequests = function (p) {
      var localVarPath = '/api/incomingCompanyMemberInviteRequests';

      _this.r(p, ["args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetIncomingCompanyMemberInviteRequestsCount = function (p) {
      var localVarPath = '/api/incomingCompanyMemberInviteRequests/unreadcount';

      _this.r(p, []);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetMyCompanyMember = function () {
      var localVarPath = '/api/companymembers/myCompanyMember';
      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, {}, bodyDict);
    };

    _this.companyMemberApiGetOutgoingCompanyMemberApplyRequest = function (p) {
      var localVarPath = '/api/outgoingCompanyMemberApplyRequests/{applyRequestId}'.replace('{' + 'applyRequestId' + '}', String(p["applyRequestId"]));

      _this.r(p, ["applyRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetOutgoingCompanyMemberApplyRequestUnreadCount = function (p) {
      var localVarPath = '/api/outgoingCompanyMemberApplyRequests/unreadcount';

      _this.r(p, []);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetOutgoingCompanyMemberApplyRequests = function (p) {
      var localVarPath = '/api/outgoingCompanyMemberApplyRequests';

      _this.r(p, ["args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetOutgoingCompanyMemberInviteRequest = function (p) {
      var localVarPath = '/api/outgoingCompanyMemberInviteRequests/{inviteRequestId}'.replace('{' + 'inviteRequestId' + '}', String(p["inviteRequestId"]));

      _this.r(p, ["inviteRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiGetOutgoingCompanyMemberInviteRequests = function (p) {
      var localVarPath = '/api/outgoingCompanyMemberInviteRequests';

      _this.r(p, ["args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiInvitationByAccountAsync = function (p) {
      var localVarPath = '/api/companymembers/_invitationbyaccount';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiInvitationUserAsync = function (p) {
      var localVarPath = '/api/companymembers/_invitationuser';

      _this.r(p, ["code"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiInvite = function (p) {
      var localVarPath = '/api/companymembers/_invite';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiKickMember = function (p) {
      var localVarPath = '/api/companymembers/_kickMember/{memberId}'.replace('{' + 'memberId' + '}', String(p["memberId"]));

      _this.r(p, ["memberId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiKickSubAdmin = function (p) {
      var localVarPath = '/api/companymembers/_kickSubAdmin/{memberId}'.replace('{' + 'memberId' + '}', String(p["memberId"]));

      _this.r(p, ["memberId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiLeave = function () {
      var localVarPath = '/api/companymembers/_leave';
      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, {}, bodyDict);
    };

    _this.companyMemberApiRejectApplyRequest = function (p) {
      var localVarPath = '/api/companymembers/_rejectApplyRequest/{applyRequestId}'.replace('{' + 'applyRequestId' + '}', String(p["applyRequestId"]));

      _this.r(p, ["applyRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiRejectInviteRequest = function (p) {
      var localVarPath = '/api/companymembers/_rejectInviteRequest/{inviteRequestId}'.replace('{' + 'inviteRequestId' + '}', String(p["inviteRequestId"]));

      _this.r(p, ["inviteRequestId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiSetCustomerServices = function (p) {
      var localVarPath = '/api/companymembers/customerServices';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.companyMemberApiTransferMainAdmin = function (p) {
      var localVarPath = '/api/companymembers/_transferMainAdmin/{memberId}'.replace('{' + 'memberId' + '}', String(p["memberId"]));

      _this.r(p, ["memberId"]);

      var bodyDict = undefined;
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    return _this;
  }

  return CompanyMemberApiApi;
}(BaseApi);

export { CompanyMemberApiApi };